import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <h4 class="mb-3 bold text-center">Aŭtuno</h4>

    <div class="poem">
      <p class="poem-block mb-3">
        Aŭtuno nebula! L’ arbar’ nudiĝanta <br/>
        Pro vento bruegas. Ĝi ŝajnas ploranta <br/>
        Pri ĉarma printempo, pri bela somero… <br/>
        Kovriĝas per koto de pluvo la tero,
      </p>

      <p class="poem-block mb-3">
        La bluo ĉiela enue nubiĝas, <br/>
        Kaj suno de l’ tero en nuboj kaŝiĝas. <br/>
        La kampoj dezertas en morna silento, <br/>
        En ili flugadas  kaj ploras nur vento!
      </p>
    </div>
  `
  )
}

const itemName = {
  esp: 'D. Egorov'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;